import { SOURCE_IDS } from "@/features/shared/utils/constants";

/**
 * BPM-26. Helpers de nombre de canal FDS, únicos para todo el proyecto.
 *
 * El backend manda el canal de dos formas según el endpoint: como id numérico
 * (`source: 4`) o como nombre libre ("Pedidos Ya", "PEDIDOS YA", "PedidosYa").
 * Antes cada pantalla se armaba su propia inversión del mapa y su propia
 * normalización, así que el mismo canal podía resolverse distinto en dos vistas.
 */

// Id numérico -> nombre de plataforma. Se arma una sola vez.
const NAME_BY_SOURCE_ID = Object.entries(SOURCE_IDS).reduce((acc, [name, id]) => {
  acc[id] = name;
  return acc;
}, {});

/**
 * Nombre de la plataforma para un id numérico del backend.
 * Devuelve undefined si el id no está mapeado, para que cada pantalla decida
 * su fallback (mostrar el id crudo, ignorarlo, etc).
 */
export function getFdsNameBySourceId(sourceId) {
  return NAME_BY_SOURCE_ID[sourceId];
}

/**
 * Clave canónica de un canal, para comparar nombres que llegan con distinta
 * capitalización o espaciado: "Pedidos Ya", "PEDIDOS YA" y "PedidosYa" dan
 * todos "pedidosya".
 */
export function normalizeFdsOriginName(name) {
  return String(name || "")
    .replace(/\s+/g, "")
    .toLowerCase();
}
